import "./App.scss";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import TranscriptUpload from "./pages/transcript-upload";
import Transcripts from "./pages/transcripts";
import SingleTranscript from "./pages/transcripts/[id]";
import { Provider } from "react-redux";
import store from "./redux/store";
import { OAuthPopup } from '@tasoskakour/react-use-oauth2';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" exact element={<TranscriptUpload />} />
          <Route path="/transcripts" exact element={<Transcripts />} />
          <Route path="/transcripts/:id" element={<SingleTranscript />} />
          <Route path="/callback" Component={OAuthPopup} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
